import { render, staticRenderFns } from "./back-btn-group.vue?vue&type=template&id=23ac7a45"
import script from "./back-btn-group.vue?vue&type=script&lang=ts"
export * from "./back-btn-group.vue?vue&type=script&lang=ts"
import style0 from "./back-btn-group.vue?vue&type=style&index=0&id=23ac7a45&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports